import { render, staticRenderFns } from "./DbpyL.vue?vue&type=template&id=48fba5b0"
import script from "./DbpyL.vue?vue&type=script&lang=js"
export * from "./DbpyL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports